import script from "./CustomReviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomReviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./CustomReviewComponent.vue?vue&type=style&index=0&id=cdabb510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdabb510"]])

export default __exports__